import LoadPanel from 'devextreme-react/load-panel'
import React, {useCallback, useEffect, useState, useRef} from "react"
import {getPoints} from "../../services/point.service"
import {getHistory, getObjects} from "../../api/range-volumes"
import notify from "devextreme/ui/notify"
import {useAuth} from "../../contexts/auth"
import {usePeriod} from "../../contexts/period"
import {verifyAccess} from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClockRotateLeft} from "@fortawesome/free-solid-svg-icons";
import PopupPointsTreeHook from "../../components/points-tree/popup-point-tree-hook"
import TreeHook from "../../components/points-tree/tree-hook";
import {useScreenSize} from "../../utils/media-query";
import SelectPeriodStart from "../../components/select-period/select-period-start";
import SelectPeriodEnd from "../../components/select-period/select-period-end";
import {getYm} from "../../utils/date.utils";
import '../range-volumes/range-volumes.scss'
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import {Button} from 'devextreme-react/button'
import DataGrid, {
    Column,
    FilterRow, HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Sorting,
} from 'devextreme-react/data-grid'

const RangeVolumesHistoryPage = () => {
    let { isLarge } = useScreenSize();
    const [visibleGrid, setVisibleGrid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [gridLoading, setGridLoading] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [selectedPoints, setSelectedPoints] = useState([])
    const { selectedDog } = useAuth()
    const { periodStart, periodEnd } = usePeriod()
    const [points, setPoints] = useState(null)
    const [visiblePage, setVisiblePage] = useState(true)
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const dataGridRef = useRef(null);
    const selectedPointsRef = useRef([])
    const refreshingRef = useRef(false)
    const showBtnRef = useRef(null)

    const onTreeSelect = useCallback((mas) => {
        const nextPoints = getPoints(mas)
        const prev = selectedPointsRef.current
        const same =
            prev.length === nextPoints.length &&
            prev.every((p, i) => String(p) === String(nextPoints[i]))

        if (same) return

        selectedPointsRef.current = nextPoints
        setSelectedPoints(nextPoints)
        setVisibleGrid(nextPoints.length > 0)
        if (nextPoints.length === 0) setDataSource([])
    }, [])

    useEffect(() => {
        const pageRoles = [2]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function () {
            setVisiblePage(true)
            setLoading(true)
            setPoints(null)
            setDataSource([])
            selectedPointsRef.current = []
            setSelectedPoints([])
            setVisibleGrid(false)
            setloadingVisibleTreeHook(true)

            const res = await getObjects(selectedDog.kodDog)
            if (res.isOk) {
                setPoints(res.data)
            } else {
                notify(res.message, 'error', 5000)
            }

            setLoading(false)
            setloadingVisibleTreeHook(false)
        })()
    }, [selectedDog])

    const syncShowButtonDisabled = useCallback((disabled) => {
        showBtnRef.current?.instance?.option('disabled', disabled)
    }, [])

    const onRefreshClick = async () => {
        if (refreshingRef.current) return
        const pointsList = selectedPointsRef.current
        if (!(pointsList.length > 0 && periodStart && periodEnd)) return

        refreshingRef.current = true
        syncShowButtonDisabled(true)
        setGridLoading(true)
        try {
            const res = await getHistory(
                selectedDog.kodDog,
                pointsList.map(Number),
                getYm(periodStart),
                getYm(periodEnd)
            )
            if (res.isOk) {
                const rows = (Array.isArray(res.data) ? res.data : []).map((row, index) => ({
                    ...row,
                    id: `${row.ym}_${row.kod_numobj}_${index}`
                }))
                setDataSource(rows)
            } else {
                notify(res.message, 'error', 5000)
                setDataSource([])
            }
        } finally {
            refreshingRef.current = false
            setGridLoading(false)
            const disabled = selectedPointsRef.current.length === 0 || !periodStart || !periodEnd
            syncShowButtonDisabled(disabled)
        }
    }

    const pageSizes = [10, 25, 50, 100]
    const showDisabled = selectedPoints.length === 0 || !periodStart || !periodEnd

    const formatYm = (ym) => {
        if (ym == null || ym === '') return ''
        const s = String(ym).replace(/[.-]/g, '')
        if (s.length < 6) return String(ym)
        const year = Number(s.slice(0, 4))
        const month = Number(s.slice(4, 6)) - 1
        if (!year || month < 0 || month > 11) return String(ym)
        const label = new Date(year, month, 1).toLocaleString('ru-RU', { month: 'long', year: 'numeric' })
        return label.charAt(0).toUpperCase() + label.slice(1)
    }

    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings big-input pokazania-edit'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faClockRotateLeft} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                <div className={''}>
                    <LoadPanel visible={loading} />
                    <div className="row mt20">
                        {!isLarge ?
                            <div className="col-md-12">
                                <PopupPointsTreeHook
                                    points={points}
                                    onSelect={onTreeSelect}
                                    typePoints={'all'}
                                    selectionMode="multiple"
                                    onShow={onRefreshClick}
                                    showDisabled={showDisabled}
                                />
                            </div>
                            :
                            <div className="col-lg-3" id='tree-hook-history'>
                                <LoadPanel position={{ of: '#tree-hook-history' }} visible={loadingVisibleTreeHook}/>
                                <TreeHook points={points} onSelect={onTreeSelect}  typePoints={'all'} selectionMode="multiple"/>
                            </div>
                        }
                        <div id='form-container-history' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                            {
                                visibleGrid ?
                                    <>
                                        <div className="range-volumes-history-toolbar">
                                            <SelectPeriodStart />
                                            <SelectPeriodEnd />
                                            {isLarge &&
                                                <Button
                                                    ref={showBtnRef}
                                                    disabled={showDisabled}
                                                    type='default'
                                                    text="Показать"
                                                    icon="refresh"
                                                    onClick={onRefreshClick}
                                                />
                                            }
                                        </div>
                                        <div id="range-volumes-history-grid-wrap">
                                            <LoadPanel
                                                position={{ of: '#range-volumes-history-grid-wrap' }}
                                                visible={gridLoading}
                                            />
                                            <DataGrid
                                            id="range-volumes-history-grid"
                                            ref={dataGridRef}
                                            dataSource={dataSource}
                                            showBorders={true}
                                            keyExpr="id"
                                            columnHidingEnabled={false}
                                            noDataText="Нет данных для отображения"
                                            wordWrapEnabled={true}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            rowAlternationEnabled={true}
                                            columnWidth={'auto'}
                                            width={'100%'}
                                            loadPanel={{ enabled: true }}
                                        >
                                            <Paging defaultPageSize={12} />
                                            <Scrolling columnRenderingMode="virtual" />
                                            <Sorting mode="multiple" />
                                            <FilterRow visible={true} />
                                            <HeaderFilter visible={true} />
                                            <Pager
                                                visible={true}
                                                allowedPageSizes={pageSizes}
                                                displayMode={'full'}
                                                showPageSizeSelector={true}
                                                showInfo={true}
                                                showNavigationButtons={true} />
                                                <Column
                                                    dataType="number"
                                                    dataField="ym"
                                                    caption="Отчётный период"
                                                    cellRender={(e) => {
                                                        // Заменяем пробел перед "г." на неразрывный пробел
                                                        const text = formatYm(e.value) || '';
                                                        const formatted = text.replace(/(\d{4})\s+г\./, '$1&nbsp;г.');
                                                        return <span dangerouslySetInnerHTML={{ __html: formatted }} />;
                                                    }}
                                                />
                                            <Column visible={false} dataField="kod_numobj" caption="Код объекта (PK)" dataType="number"/>
                                            <Column visible={false} dataField="kod_obj" caption="Код объекта" dataType="number"/>
                                            <Column dataField="num_obj" caption="№ объекта энергоснабжения" dataType="number" width={70} fixed={true} fixedPosition="left"/>
                                            <Column dataField="name" caption="Наименование объекта энергоснабжения" dataType="string" fixed={true} fixedPosition="left"/>
                                            <Column dataField="adr" caption="Адрес объекта энергоснабжения" dataType="string"/>
                                            <Column
                                                dataField="col6_ls_d1"
                                                caption="Кол-во ЛС ФЛ по 1 диапазону без многодетных, шт."
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col7_vol_d1"
                                                caption="Суммарный ОБЪЁМ по 1 диапазону без многодетных, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col8_vol_odn_d1"
                                                caption="Суммарный ОБЪЁМ ОДН по 1 диапазону, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col9_ls_md_d1"
                                                caption="Кол-во многодетных ЛС ФЛ по 1 диапазону, шт."
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col10_vol_md_d1"
                                                caption="Суммарный ОБЪЁМ по 1 диапазону по многодетным ЛС, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col11_ls_d2"
                                                caption="Кол-во ЛС ФЛ по 2 диапазону, шт."
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col12_vol_d2"
                                                caption="Суммарный ОБЪЁМ по 2 диапазону, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col13_ls_d3"
                                                caption="Количество ЛС ФЛ по 3 диапазону, шт."
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col14_vol_d3"
                                                caption="Суммарный ОБЪЁМ по 3 диапазону, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column
                                                dataField="col5_vol_total"
                                                caption="Суммарный ОБЪЁМ по всем диапазонам, кВт·ч"
                                                dataType="number"
                                            />
                                            <Column dataField="t_sent" caption="Дата передачи" dataType="datetime"/>
                                        </DataGrid>
                                        </div>
                                    </>
                                    :
                                    <div className='text-center-horizontal-vertical d-none d-md-block'><strong>Для просмотра истории выберите объекты и нажмите кнопку «Показать»</strong></div>

                            }
                        </div>
                    </div>
                </div>
            </div>
            : <AccessDenied/>}</>
    )
}

export default RangeVolumesHistoryPage
